export const SERVICE_CATEGORIES = [
  { key: "all", label: "All" },
  { key: "cricket_ground", label: "Cricket Ground" },
  { key: "indoor_box", label: "Indoor Box" },
  { key: "academy_drills", label: "Academy Drills" },
  { key: "badminton", label: "Badminton" },
  { key: "gym", label: "Gym" },
];

export const BLOG_CATEGORIES = ["all", "Training", "Community", "Wellness", "News"];

export const HOURS = Array.from({ length: 17 }, (_, i) => i + 6); // 6..22

export function formatHour(h) {
  const h12 = ((h + 11) % 12) + 1;
  return `${h12}${h < 12 ? "AM" : "PM"}`;
}

export function formatINR(n) {
  return "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
}
